(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairCounselorsController', VirtualFairCounselorsController);

    VirtualFairCounselorsController.$inject = ['VirtualFairService', '$timeout'];

    function VirtualFairCounselorsController(VirtualFairService, $timeout) {
        var vm = this;

        vm.flag                     = false;
        vm.isNetworking             = false;
        vm.virtualFairs             = [];
        vm.virtualFairSelected      = [];

        vm.selectVirtualFairs       = selectVirtualFairs;
        vm.getByFilter              = getByFilter;
        vm.downloadCSV              = downloadCSV;

        /* PAGINATION */
        vm.pageChanged = pageChanged;
        vm.setPage = setPage;
        vm.totalItems = [];
        vm.currentPage = null;
        vm.itemsPerPage = [];
        vm.page = 1;

        function activate() {
            vm.selectVirtualFairs();
        }

        function selectVirtualFairs() {
            VirtualFairService.getAll().then(function (response) {
                vm.virtualFairs = response.data;
            }).catch(function (err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};

            vm.query['virtual_fair_id'] = vm.virtualFairSelected.id;
            if (vm.page !== null) {
                vm.query['page'] = vm.page;
            }

            VirtualFairService.getCounselors(vm.query).then(function (response) {
                vm.response = response.data.data;
                vm.isNetworking = response.data.is_networking;
                if (vm.response.length === 0) {
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
                vm.totalItems = response.data.total;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function (err) {
            });
        }

        function setPage(pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged() {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function downloadCSV() {
            vm.query = {};
            vm.query['virtual_fair_id'] = vm.virtualFairSelected.id;

            VirtualFairService.getCounselorsCsv(vm.query).success(function (data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = (vm.isNetworking ? 'networking_' : '') + 'vf_counselors_' + vm.virtualFairSelected.id + '.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).error(function (data, status, headers, config) {
            });
        }

        activate();
    }

})();
